import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import Routes, { DELIVERY_ID_PARAM } from 'routes';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';
import { useCheckInTraysBySet } from 'hooks/useCheckInTraysBySet';

type Props = {
  deliveryId: string;
  onClose: () => void;
  onCancel: () => void;
};

export const CheckInDeliveryDialog = ({ deliveryId, onClose, onCancel }: Props) => {
  const lang = useLanguage()[0].CheckInDeliveryDialog;

  const navigate = useNavigate();

  const setCheckInTraysBySet = useCheckInTraysBySet()[1];

  const onConfirm = useCallback(async () => {
    setCheckInTraysBySet({});
    onClose();
    navigate(Routes.CheckInWorkflow.path.replace(DELIVERY_ID_PARAM, deliveryId));
  }, [deliveryId, navigate, onClose, setCheckInTraysBySet]);

  return (
    <Dialog
      open
      title={lang.title}
      cancelLabel={lang.cancel}
      confirmLabel={lang.confirm}
      onClose={onClose}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};
